import { engineComponent } from "neo-common";
import { HtmlStyle } from "./HtmlStyle";
import { ComponentTypes } from "../../Components/ComponentTypes";

/**
 * HtmlContainerStyle only holds xml node for html container elements.
 * Example:
 *   <HtmlContainerStyle Class="HtmlContainerStyle">
 *       <Child1 />
 *       <Child1 />
 *       ...
 *   </HtmlContainerStyle>
 * @class HtmlContainerStyle
 */
@engineComponent(ComponentTypes.HtmlStyle)
export class HtmlContainerStyle extends HtmlStyle {
    node: Element;

    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @retutn void
     */
    create(node: Element): void {
        super.create(node);

        // store node for container elements
        this.node = node;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Styles/HtmlContainerStyle.ts
 **/